export default {
  
    Clients: 'Client|Clients',
};
